import formatLocale from "./locale";

var locale;
export var format;
export var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

export default function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-format/src/defaultLocale.js
// module id = 1102
// module chunks = 0